var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"none","d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("line",{"x1":"12","y1":"5","x2":"12","y2":"19","key":1}),React.createElement("line",{"x1":"18","y1":"11","x2":"12","y2":"5","key":2}),React.createElement("line",{"x1":"6","y1":"11","x2":"12","y2":"5","key":3})]);
}

ArrowUp.defaultProps = {"className":"icon icon-tabler icon-tabler-arrow-up","width":"24","height":"24","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
